export const locale = {
  required: "Поле обязательно",
  notValid: "Поле не валидно",
  notInteger: "Значение не является целым",
  minValue: "Минимальное значение",
  maxValue: "Максимальное значение",
  minLength: (len: number) => `Минимальная длина ${len} символов`,
  maxLength: (len: number) => `Максимальная длина ${len} символов`,
  dateFormat: "Дата указана не корректно",
  datetimeFormat: "Дата или время указано не корректно",
  dateInThePast: "Дата не может быть в прошлом",
  dateNotInFuture: "Дата не может быть в будущем",
  dateTimeInThePast: "Дата или время не может быть в прошлом",
  dateEndBeforeStart: "Дата окончания не может быть раньше даты начала заказа",
  collectionEndOutOfRange: "Дата и время должны быть между началом сбора и окончанием сессии",
  retradingEndOutOfRange: "Дата и время должны быть между окончанием сбора и окончанием сессии",
  resultsBeforePreviousStage: "Подведение итогов не может быть раньше окончания предыдущего этапа",
  resultsMustMatchTradeEnd: "Подведение итогов и окончание сессии должны совпадать",
  deadlineToOutOfRange: "Дата окончания не может быть раньше даты начала",
  decadeSumExceedsTotal: "Сумма вагонов по декадам не должна превышать общее количество вагонов",
  unloadingDirectionSumExceedsTotal:
    "Сумма вагонов по направлениям выгрузки не должна превышать общее количество вагонов",
  deadlineAtBeforeTradeEnd: "Период действия заявки С не может быть раньше даты окончания сессии",
  dateMoreThanYearInFuture: "Дата не может быть в будущем более чем на год",
  datetimeMoreThanYearInFuture: "Дата и время не могут быть в будущем более чем на год",
  // Валидация полей пользователя
  invalidEmailFormat: "Неверный формат email",
  phoneMinLength: "Номер телефона должен содержать минимум 10 цифр",
  // Валидация ИНН, КПП, ОГРН
  innFormat: "ИНН должен содержать 12 символов",
  kppFormat: "КПП должен содержать 9 символов",
  ogrnFormat: "ОГРН должен содержать 13 символов",
} as const;
